import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const items = ['The Complete 50+ Page Cortisol Reset Digital Guide', "The 4-Minute 'Pillow-Tap' Somatic Sequence (Step-by-Step)", 'The Adrenal Cocktail 2.0 Recipe for 3 PM Energy Stabilization', 'The 7-Day Implementation Grid for guaranteed results', "The 'Kitchen-Shelf' Supply List (Simple items you already own)", 'The Midnight Salt-and-Citrus Trick for 3 AM wake-ups'];
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      x: -20
    },
    show: {
      opacity: 1,
      x: 0
    }
  };
  return <section className="bg-cream-200 py-24 px-6" data-id="element-157">
      <div className="container mx-auto max-w-5xl" data-id="element-158">
        <div className="grid lg:grid-cols-5 gap-12 items-center" data-id="element-159">
          <div className="lg:col-span-2" data-id="element-160">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-161">
              <img src="https://cdn.magicpatterns.com/uploads/ihVeVKS6mg2xzSnDj9ssrf/heylloyd-image-1774894106555.png" alt="Protocol Contents" className="w-full rounded-2xl shadow-xl" data-id="element-162" />
            </motion.div>
          </div>

          <div className="lg:col-span-3" data-id="element-163">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="mb-10" data-id="element-164">
              <h2 className="font-serif text-4xl md:text-5xl text-navy-900 mb-4" data-id="element-165">
                Everything Inside the Protocol
              </h2>
              <div className="w-16 h-1 bg-gold-500 rounded-full" data-id="element-166"></div>
            </motion.div>

            <motion.ul variants={container} initial="hidden" whileInView="show" viewport={{
            once: true
          }} className="space-y-6" data-id="element-167">
              {items.map((text, index) => <motion.li key={index} variants={item} className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm border border-cream-300/50" data-id="element-168">
                  <CheckCircle2 className="text-gold-600 shrink-0 mt-1" size={24} data-id="element-169" />
                  <span className="text-navy-800 text-lg font-medium leading-relaxed" data-id="element-170">
                    {text}
                  </span>
                </motion.li>)}
            </motion.ul>
          </div>
        </div>
      </div>
    </section>;
}